// The original outstanding stays separate from Amount: editing the receipt must not change the base of its adjustment.
// Delegation also covers rows added by the grid and rows loaded by Receipt Kind.
function calculateAdjustment(row: HTMLTableRowElement): void {
  const amount = row.querySelector<HTMLInputElement>("[data-kit-col='amount']");
  const outstanding = row.querySelector<HTMLInputElement>("[data-mr-outstanding]");
  const adjustment = row.querySelector<HTMLInputElement>("[data-kit-col='adjAmount']");
  if (!amount || !adjustment) return;
  if (!outstanding?.value) { adjustment.value = "0.00"; return; }
  const open = Number(outstanding.value.replace(/,/g, ""));
  const received = Number(amount.value.replace(/,/g, ""));
  if (!Number.isFinite(open) || !Number.isFinite(received)) return;
  adjustment.value = Math.max(0, open - received).toFixed(2);
}
document.addEventListener("input", (e) => {
  const field = e.target;
  if (!(field instanceof HTMLInputElement) || !field.closest("form[data-money-receipt]")) return;
  if (field.dataset.kitCol !== "amount" && !field.hasAttribute("data-kit-lookup-key")) return;
  const row = field.closest("tr");
  if (row) calculateAdjustment(row);
});
document.addEventListener("kit:row-filled", (e) => {
  const row = e.target;
  if (row instanceof HTMLTableRowElement && row.closest("form[data-money-receipt]")) calculateAdjustment(row);
});
